import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import type { ReactNode } from 'react';
import { CardsIllustration } from './CardsIllustration';
export function PostSignupHeader(t0) {
  const $ = _c(9);
  const {
    children
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("flex", "flex-col", "gap-6", "sm:max-w-[636px]");
    t2 = <div className={clsx("flex", "flex-col", "gap-2")}><h1 className={clsx("text-[30px]", "font-bold", "m-0")}><span className={clsx("text-black")}>Congratulations,</span><span className={clsx("text-green-default")}> you're on the list!</span></h1><p className={clsx("text-base", "text-black", "sm:text-neutral-darker-2", "m-0")}>Check your inbox for your first edition of TravelNerd.</p></div>;
    t3 = <hr className={clsx("w-full", "border-t", "border-green-default", "opacity-12", "m-0")} />;
    t4 = clsx("flex", "gap-x-4", "gap-y-1", "items-start", "flex-wrap");
    t5 = <div className={clsx("hidden", "sm:block", "shrink-0")}><CardsIllustration aria-hidden="true" /></div>;
    t6 = clsx("flex", "flex-col", "gap-6", "w-full", "basis-xs", "grow");
    t7 = <div className={clsx("flex", "flex-col", "gap-1")}><p className={clsx("text-base", "font-bold", "text-black", "m-0", "leading-normal")}>Up next: Jumpstart your travels with the best travel card</p><p className={clsx("text-xsmall", "text-neutral-darker-2", "m-0")}>Credit card rewards are key to unlocking more affordable trips. CardFinder will match you with the best travel card for your goals in just a few minutes.</p></div>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] !== children) {
    t8 = <section className={t1}>{t2}{t3}<div className={t4}>{t5}<div className={t6}>{t7}{children}</div></div></section>;
    $[7] = children;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}